var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 19.5C1.69771 19.5 1.25 19.0523 1.25 18.5V10C1.25 9.44772 1.69772 9 2.25 9H7.22484L9.265 1.48791C9.3833 1.05234 9.7829 0.733219 10.2259 0.819375C11.8265 1.13063 12.4528 2.44031 12.4528 3.75V7.5C12.4528 7.5 17.6808 7.5 19.4733 7.5C20.2948 7.5 20.8176 8.4 20.7429 9.225L19.6973 18.225C19.6226 18.975 18.9505 19.5 18.2036 19.5H2.25Z",
    stroke: "#131A46",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9215 13.5H16.9341",
    stroke: "#131A46",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9215 16.5H16.9341",
    stroke: "#131A46",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6684 10.5H16.9341",
    stroke: "#131A46",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.76546 12.5303C5.05712 12.2374 5.05712 11.7626 4.76546 11.4697C4.47379 11.1768 4.00092 11.1768 3.70925 11.4697C3.41759 11.7626 3.41759 12.2374 3.70925 12.5303C4.00092 12.8232 4.47379 12.8232 4.76546 12.5303Z",
    fill: "#131A46"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.22461 9V19.5",
    stroke: "#131A46",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.6e000c89.svg";
export { ForwardRef as ReactComponent };